<div class="container-fluid bg-white default-boxrounded">
    <div class="col-12 w-100 row">
        <h3 class="title col-9">
            <span [translate]="TitleTranslationKey"></span>
        </h3>
    </div>
    <ng-content></ng-content>
</div>